const RELOAD_KEY = "elelem_chunk_reload_attempted";
const getBuildReloadKey = () =>
  `${RELOAD_KEY}:${process.env.REACT_APP_COMMIT_SHA || "local"}`;

export const isChunkLoadError = (error) => {
  if (!error) return false;
  const text = `${error.name || ""} ${error.message || ""}`;
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk|Failed to fetch dynamically imported module/i.test(
    text,
  );
};

/**
 * Hard-reloads once if `error` is a missing-chunk error (stale tab after a
 * deploy). A sessionStorage flag prevents reload loops for the current build.
 * Returns true if a reload was triggered.
 */
export const reloadOnceForChunkError = (error) => {
  if (!isChunkLoadError(error)) return false;
  try {
    const reloadKey = getBuildReloadKey();
    if (sessionStorage.getItem(reloadKey)) return false;
    sessionStorage.setItem(reloadKey, "1");
  } catch {
    return false;
  }
  window.location.reload();
  return true;
};
